<style scoped>
.item-title {
  padding-left: 24px;
}
</style>

<template>

<div>
  <transition name="fade">
    <mu-paper :z-depth="1" v-if="flagFetchedUsers">
      <mu-tabs :value.sync="tab" center inverse full-width>
        <mu-tab>
          <mu-icon value="show_chart"></mu-icon>
          {{$t('stat.user_realtime')}}
        </mu-tab>
        <mu-tab>
          <mu-icon value="people"></mu-icon>
          {{$t('users.title')}}
        </mu-tab>
      </mu-tabs>
      <UserRealtime v-if="tab === 0"/>
      <mu-paper :z-depth="1" v-if="tab === 1">
        <div class="display-flex">
          <h1 class="item-title">{{$t('users.title')}}</h1>
          <span class="flex-item" />
          <mu-text-field v-model="modelSearch" icon="search"></mu-text-field>
          <mu-button icon @click="onClickAttachment" v-tooltip="$t('users.attachment')">
            <mu-icon value="attachment"></mu-icon>
          </mu-button>
          <mu-button icon @click="flagDialogCreate = true;" v-tooltip="$t('button.add') + $t('space') + $t('users.display')">
            <mu-icon value="add"></mu-icon>
          </mu-button>
        </div>
        <mu-data-table :columns="columns" stripe :data="searched.slice((currentPage - 1) * itemsPerPage, (currentPage - 1) * itemsPerPage + itemsPerPage)" :no-data-text="$t('empty.noDataTitle')">
          <template slot-scope="scope">
          <td>{{scope.row.name}} ({{scope.row.username}})</td>
          <td>{{scope.row.email}}</td>
          <td>{{ $t('profile.type.' + scope.row.type) }}</td>
          <td>{{ stringRole(scope.row.roles) }}</td>
          <td>{{ stringLastActiveAt(scope.row) }}</td>
          <td>
            <mu-button icon @click="onClickEdit(scope.row)" color="primary">
              <mu-icon value="edit"></mu-icon>
            </mu-button>
            <mu-button icon @click="onClickDelete(scope.row._id)" color="secondary">
              <mu-icon value="delete"></mu-icon>
            </mu-button>
          </td>
          </template>
        </mu-data-table>
        <mu-flex justify-content="center">
          <mu-pagination :total="searchedTotal" :current.sync="currentPage" :page-size="itemsPerPage"></mu-pagination>
        </mu-flex>
      </mu-paper>
    </mu-paper>
  </transition>
  <mu-dialog :title="$t('button.add') + $t('space') + $t('users.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogCreate">
    <mu-form :model="form" label-width="500">
      <mu-form-item prop="radio" :label="$t('profile.type.display')">
        <mu-radio v-model="modelType" value="guest" :label="$t('profile.type.guest')"></mu-radio>
        <mu-radio v-model="modelType" value="cas" :label="$t('profile.type.cas')"></mu-radio>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('profile.username')">
        <mu-text-field v-model="modelUser.username"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('profile.fullname')">
        <mu-text-field v-model="modelUser.name"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('profile.email')">
        <mu-text-field v-model="modelUser.email"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('profile.password.display')" v-if="modelType === 'guest'">
        <mu-text-field v-model="modelUser.password"  :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="checkbox" :label="$t('profile.role')">
        <mu-radio v-for="(role, index) in roles" v-model="modelRole" :value="role" :key="index" :label="role"></mu-radio>
      </mu-form-item>
    </mu-form>
    <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button type="submit" slot="actions" flat color="primary" @click.stop.prevent="onActionCreate"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
  <mu-dialog :title="$t('button.edit') + $t('space') + $t('users.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEdit">
    <mu-form :model="form" label-width="500">
      <mu-form-item prop="input" :label="$t('profile.username')">
        <mu-text-field v-model="modelUser.username"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('profile.fullname')">
        <mu-text-field v-model="modelUser.name"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('profile.email')">
        <mu-text-field v-model="modelUser.email"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="checkbox" :label="$t('profile.role')">
        <mu-radio v-for="(role, index) in roles" v-model="modelRole" :value="role" :key="index" :label="role"></mu-radio>
      </mu-form-item>
    </mu-form>
    <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button type="submit" slot="actions" flat color="primary" @click.stop.prevent="onActionEdit"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
  <mu-dialog :title="$t('button.delete') + $t('space') + $t('users.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="flagDialogDelete = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
  <mu-dialog :title="$t('users.attachment')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogAttachment">
    <input type="file" id="file" ref="file" @change="onFileChange" />
    <div><mu-checkbox v-model="modelHeader" :label="$t('users.csv.header')"></mu-checkbox></div>
    <div>{{$t('users.csv.format')}}</div>
    <mu-button slot="actions" flat color="primary" @click="flagDialogAttachment = false;"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click.prevent="onActionAttachment" :disabled="!isFileValid"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>
// Library
import axios from "axios";
import mime from 'mime-types'

import lastTimeAt from '@/utils/lastTimeAt.js'

// Components
import UserRealtime from "@/components/Analytics/User/UserRealtime.vue";

export default {
  name: 'UsersPage',
  components: {
    UserRealtime
  },
  data() {
    return {
      roles: ["student", "assistant", "teacher", "admin"],

      // Object
      users: [],
      emptyUser: {
        username: "",
        name: "",
        email: "",
        roles: [""]
      },

      // Model
      modelUser: {
        username: "",
        name: "",
        email: "",
        roles: [""],
        password: ""
      },
      modelRole: "",
      modelType: "guest",
      modelUserId: "",
      modelFilename: "", // Bind with file name input
      modelFile: "", // Bind with file input
      modelHeader: true,
      modelSearch: "",
      form: {},

      // Flag
      flagFetchedUsers: false, // Boolean variable for status of users fetched
      flagDialogEdit: false,
      flagDialogDelete: false,
      flagDialogCreate: false,
      flagDialogAttachment: false,
      visibility: false,

      // Table
      currentPage: 1,
      itemsPerPage: 10,
      tab: 0,

    }
  },
  computed: {
    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    // Flag
    isFileValid() {
      return this.modelFile !== "" && this.modelFilename !== "" && this.modelType === "csv";
    },

    // String
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.modelUser.name });
    },

    columns() {
      var array = [
        { title: this.$t('profile.username'), name: 'username' },
        { title: this.$t('profile.email'), name: 'email' },
        { title: this.$t('profile.type.display'), name: 'type' },
        { title: this.$t('profile.role'), name: 'role' },
        { title: this.$t('profile.last_active_at'), name: 'last_active_at' },
        { title: this.$t('button.manage'), name: 'manage' },
      ];
      return array;
    },

    searched() {
      if(this.modelSearch.length > 0) {
        return this.searchBy(this.users, this.modelSearch);
      } else {
        return this.users;
      }
    },
    searchedTotal() {
      return this.searched.length;
    },
  },
  watch: {
    triggerRefresh() {
      this.fetchUsers();
    },
    modelSearch() {
      this.currentPage = 1;
    }
  },
  created() {
    if(this.isAdmin) {

      this.fetchUsers();
    } else {
      this.$router.push({
        name: 'Home'
      });
    }
  },
  methods: {
    // Fetch
    fetchUsers() {
      axios.get(this.$store.getters.urlApi + "user", {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.users = response.data.data.users
        this.flagFetchedUsers = true;
      });
    },

    // Event
    onClickEdit(user) {
      this.modelUser = user;
      this.modelRole = user.roles[0];
      this.modelUserId = user._id;
      this.flagDialogEdit = true;
    },
    onActionCancel() {
      this.modelUser = this.emptyUser;
      this.modelUserId = "";
      this.flagDialogEdit = false;
      this.flagDialogCreate = false;
    },
    onActionEdit() {
      this.flagDialogEdit = false;
      axios.put(this.$store.getters.urlApi + "user/" + this.modelUserId, {
        name: this.modelUser.name,
        username: this.modelUser.username,
        email: this.modelUser.email,
        role: this.modelRole
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onClickDelete(user_id) {
      this.flagDialogDelete = true;
      this.modelUserId = user_id;
    },
    onActionDelete() {
      this.flagDialogDelete = false;
      axios.delete(this.$store.getters.urlApi + "user", {
        headers: {
          token: this.$store.state.auth.token
        },
        params: {
          user_id: this.modelUserId
        }
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.delete'));
      });
    },
    onActionCreate() {
      this.flagDialogCreate = false;
      axios.post(this.$store.getters.urlApi + "user", {
        name: this.modelUser.name,
        username: this.modelUser.username,
        email: this.modelUser.email,
        role: this.modelRole,
        password: this.modelUser.password,
        type: this.modelType
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.create'));
      });
    },
    onClickAttachment() {
      this.flagDialogAttachment = true;
    },
    onFileChange() {
      if (this.$refs.file.files[0] != undefined) {
        this.modelFile = this.$refs.file.files[0];
        this.modelFilename = this.$refs.file.files[0].name;
        var type = mime.lookup(this.modelFilename);
        if (type === "text/csv") {
          this.modelType = "csv";
        } else {
          this.modelType = "unknown";
          this.modelFile = ""
          this.modelFilename = "";
        }
      } else {
        this.modelType = "empty";
        this.modelFile = ""
        this.modelFilename = "";
      }
    },
    onActionAttachment() {
      this.flagDialogAttachment = false;

      let formData = new FormData();
      formData.append('file', this.modelFile);
      formData.append('modelFilename', this.modelFilename);
      formData.append('header', this.modelHeader);
      axios.post(this.$store.getters.urlApi + "user/attachment", formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.modelFile = "";
        this.modelFilename = "";
        this.$emit('triggerRefresh');
        this.$toast.success(this.$t('toast.create'));
      });
    },

    // String
    stringRole(roles) {
      return roles.join(', ');
    },
    stringLastActiveAt(user) {
      if(user.hasOwnProperty('last_active_at')) {
        var d = lastTimeAt(user.last_active_at.date);
        return d.value + this.$t(d.suffix);
      } else {
        return this.$t('admin.no_record');
      }
    },
    
    toLower(text) {
      if(text)
        return text.toString().toLowerCase();
      else
        return "";
    },
    searchBy(items, term) {
      if (term) {
        return items.filter(item =>
        this.toLower(item.name).includes(this.toLower(term.trim())) ||
        this.toLower(item.email).includes(this.toLower(term.trim())) ||
        this.toLower(item.username).includes(this.toLower(term.trim()))
        )
      }

      return items
    },
  }
}
</script>
